import { Schema } from "src/app/reports/shared/rte-form/schema/schema.model";

export class UploadedValuesConfirmConfig {
  Schemas: Schema[];
  Value: string;
}

export class UploadValuesConfirmed {
  Schema: Schema;
  Value: string;
}
